import clsx from "clsx";
import { CheckIcon } from "@/shared/icons";

type Props = {
  text: string;
  currentCount: number;
  maxCount: number;
  isCompleted: boolean;
};

export default function FactionOptionItem({ text, currentCount, maxCount, isCompleted }: Props) {
  return (
    <div className="flex justify-between items-center overflow-clip">
      <p className="max-w-[7.375rem] text-13 font-medium">{text}</p>
      <div
        className={clsx(
          "relative min-w-13.5 min-h-9 flex justify-center items-center p-2.5 text-14 font-medium leading-none bg-[#1C1C1C] rounded-xl",
          currentCount === maxCount ? "text-white/15" : "text-white/70",
        )}
      >
        {currentCount}/{maxCount}
        {isCompleted && (
          <div
            className="absolute top-0 left-0 flex justify-center items-center size-full rounded-xl"
            style={{
              background:
                "radial-gradient(70.86% 70.84% at 50% 50%, rgba(132, 255, 151, 0.40) 0%, rgba(132, 255, 151, 0.00) 100%)",
            }}
          >
            <CheckIcon className="size-3.5 text-[#84FF97]" />
          </div>
        )}
      </div>
    </div>
  );
}
